import Auth from './auth/reducer';
import App from './app/reducer';
import ToolOperator from './tooloperator/reducers'
import Telepase from './telepase/reducer';
import Reports from './informe/reducer';
export default {
  Auth,
  App,
  Telepase,
  ToolOperator,
  Reports
};
